// extracted by mini-css-extract-plugin
export default {"root":"tWWUdHCbseoQt4e27Vjj"};